<template>
  <div class="d-inline">
    <v-btn icon title="Gerar Comprovante" v-on:click="showReceipt()">
      <v-icon>mdi-printer</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline teal white--text darken-4">
          Comprovante de Protocolo
        </v-card-title>

        <v-card-text>
          Seu comprovante foi gerado com sucesso. Clique no botão abaixo para visualizar
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" flat @click="dialog = false">
            Cancelar
          </v-btn>
          <a class="v-btn primary" :href="url" target="_blank">Visualizar</a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApplicationService from '@/services/applications/ApplicationService';

export default {
  name: 'ApprovedApplication',
  props: ['application'],
  data() {
    return {
      dialog: false,
      url: '',
    };
  },
  methods: {
    showReceipt() {
      this.$store.dispatch('setLoadingDialog', true);
      const vm = this;
      ApplicationService
        .showReceipt(this.application.id)
        .then((response) => {
          vm.url = response.data.tmp_url;
          vm.dialog = true;
        })
        .catch(() => {
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
  },
};
</script>
